import React from "react";
import Chart from "react-apexcharts";
import useDashboardStats from "../hooks/useDashboardStats";
import "./stickyloder.css";

const TopCountriesRevenueChart = () => {
  const { analytics, loading, error } = useDashboardStats();

  if (loading)
    return (
      <div className="top-loader">
        <div className="top-loader-bar"></div>
      </div>
    );

  if (error) return <div>Failed to load top countries revenue</div>;

  // Extract data
  let categories =
    analytics?.top_countries_revenue?.map((c) => c.country_code || "Unknown") ||
    [];
  let seriesData =
    analytics?.top_countries_revenue?.map((c) =>
      parseFloat(c.total_revenue_gbp)
    ) || [];

  // Ensure minimum 3 bars with default "N/A" and 0
  while (categories.length < 3) {
    categories.push("N/A");
    seriesData.push(0);
  }

  return (
    <div className="card p-3">
      <h5>Top Countries Revenue (GBP)</h5>
      <Chart
        options={{
          chart: { type: "bar", height: 300 },
          xaxis: { categories },
          dataLabels: { enabled: true },
          yaxis: { labels: { formatter: (val) => `£${val.toFixed(2)}` } },
        }}
        series={[{ name: "Revenue", data: seriesData }]}
        type="bar"
        height={300}
      />
    </div>
  );
};

export default TopCountriesRevenueChart;
